import React from "react";
// nodejs library that concatenates classes
import classnames from "classnames";
import SimpleFooter from "components/Footers/SimpleFooter.js";

// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardImg,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
  Form,
  Alert,
} from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";

// index page sections
import Download from "../IndexSections/Download.js";

class ContactPage extends React.Component {
  state = {
    formData: {
      name: "",
      email: "",
      phone: "",
      company: "",
      subject: "",
      message: ""
    },
    formStatus: {
      submitted: false,
      success: false,
      error: ""
    }
  };

  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: value
      }
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { formData } = this.state;
    
    // Basic validation
    if (!formData.name || !formData.email || !formData.message) {
      this.setState({
        formStatus: {
          submitted: true,
          success: false,
          error: "Veuillez remplir tous les champs obligatoires."
        }
      });
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      this.setState({
        formStatus: {
          submitted: true,
          success: false,
          error: "Veuillez entrer une adresse email valide."
        }
      });
      return;
    }

    // Simulate form submission
    this.setState({
      formStatus: {
        submitted: true,
        success: true,
        error: ""
      },
      formData: {
        name: "",
        email: "",
        phone: "",
        company: "",
        subject: "",
        message: ""
      }
    });

    // Reset success message after 5 seconds
    setTimeout(() => {
      this.setState({
        formStatus: {
          submitted: false,
          success: false,
          error: ""
        }
      });
    }, 5000);
  }
  render() {
    const { formData, formStatus } = this.state;
    
    return (
      <>
        <DemoNavbar />
        <main ref="main">
          <div className="position-relative">
            {/* Enhanced Hero Section */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row className="align-items-center">
                    <Col lg="6">
                      <div className="pr-5">
                        <h1 className="display-3 text-white">
                          Contactez <span className="text-warning">Solution Nügaz</span>
                        </h1>
                        <p className="lead text-white">
                          Notre équipe d'experts en gaz naturel est à votre disposition pour vous accompagner dans tous vos projets. 
                          Avec plus de 14 ans d'expérience, nous vous offrons un service personnalisé et des solutions adaptées à vos besoins.
                        </p>
                        <div className="btn-wrapper mt-4">
                          <Button
                            className="btn-icon mb-3 mb-sm-0"
                            color="info"
                            size="lg"
                            href="mailto:nvincent@nugaz.com"
                          >
                            <span className="btn-inner--icon mr-2">
                              <i className="ni ni-email-83" />
                            </span>
                            <span className="btn-inner--text">Écrivez-nous</span>
                          </Button>
                          <Button
                            className="btn-white btn-icon mb-3 mb-sm-0 ml-3"
                            color="default"
                            size="lg"
                            href="tel:+4184070863"
                          >
                            <span className="btn-inner--icon mr-2">
                              <i className="ni ni-mobile-button" />
                            </span>
                            <span className="btn-inner--text">418-407-0863</span>
                          </Button>
                        </div>
                      </div>
                    </Col>
                    <Col lg="6">
                      <div className="pr-lg-0 pr-5">
                        <Row>
                          <Col className="mb-4">
                            <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                              <i className="ni ni-satisfied text-primary" />
                            </div>
                            <h5 className="text-white mt-3">Service personnalisé</h5>
                            <p className="text-white opacity-8">
                              Une approche sur mesure pour chaque client
                            </p>
                          </Col>
                          <Col className="mb-4">
                            <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                              <i className="ni ni-delivery-fast text-primary" />
                            </div>
                            <h5 className="text-white mt-3">Réactivité</h5>
                            <p className="text-white opacity-8">
                              Réponse rapide à toutes vos demandes
                            </p>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="mb-4">
                            <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                              <i className="ni ni-like-2 text-primary" />
                            </div>
                            <h5 className="text-white mt-3">14 ans d'expérience</h5>
                            <p className="text-white opacity-8">
                              Une expertise reconnue au Québec
                            </p>
                          </Col>
                          <Col className="mb-4">
                            <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                              <i className="ni ni-support-16 text-primary" />
                            </div>
                            <h5 className="text-white mt-3">Support 24/7</h5>
                            <p className="text-white opacity-8">
                              Assistance disponible en tout temps
                            </p>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Container>
              <div className="separator separator-bottom separator-skew">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 100"
                  x="0"
                  y="0"
                >
                  <polygon
                    className="fill-white"
                    points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>

          {/* Enhanced Team Section */}
          <section className="section section-lg pt-lg-0">
            <Container>
              <Row className="justify-content-center mb-5">
                <Col lg="8" className="text-center">
                  <h2 className="display-3">Notre équipe d'experts</h2>
                  <p className="lead text-muted">
                    Rencontrez les professionnels qui vous accompagnent dans vos projets de gaz naturel
                  </p>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="4" className="mb-5">
                      <Card className="card-lift--hover shadow border-0 h-100">
                        <CardBody className="py-5 text-center">
                          <div className="mb-5 d-flex justify-content-center">
                            <div className="avatar avatar-xl">
                              <img
                                alt="Nicolas Vincent"
                                style={{ 
                                  width: "150px", 
                                  height: "150px",
                                  objectFit: "cover"
                                }}
                                className="rounded-circle shadow-lg"
                                src={require("assets/img/NicolasVincent.jpg")}
                              />
                            </div>
                          </div>
                          <h4 className="text-warning mb-2">
                            Nicolas Vincent
                          </h4>
                          <h6 className="text-muted text-uppercase font-weight-bold mb-3">
                            Directeur général
                          </h6>
                          <p className="description text-muted">
                            Avec plus de 14 ans d'expérience dans l'industrie du gaz naturel, 
                            Nicolas dirige l'équipe avec expertise et passion.
                          </p>
                          <div className="mt-4">
                            <Button
                              className="btn-neutral btn-icon-only btn-sm mb-2 mr-2"
                              color="default"
                              href="mailto:nvincent@nugaz.com"
                              size="sm"
                            >
                              <span className="btn-inner--icon">
                                <i className="ni ni-email-83" />
                              </span>
                            </Button>
                            <Button
                              className="btn-neutral btn-icon-only btn-sm mb-2"
                              color="default"
                              href="tel:+4189530318"
                              size="sm"
                            >
                              <span className="btn-inner--icon">
                                <i className="ni ni-mobile-button" />
                              </span>
                            </Button>
                          </div>
                          <div className="mt-3">
                            <small className="text-muted d-block">nvincent@nugaz.com</small>
                            <small className="text-muted d-block">418-953-0318</small>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4" className="mb-5">
                      <Card className="card-lift--hover shadow border-0 h-100">
                        <CardBody className="py-5 text-center">
                          <div className="mb-5 d-flex justify-content-center">
                            <div className="avatar avatar-xl">
                              <img
                                alt="Paul Raymond"
                                style={{ 
                                  width: "150px", 
                                  height: "150px",
                                  objectFit: "cover"
                                }}
                                className="rounded-circle shadow-lg"
                                src={require("assets/img/PaulRaymond.jpg")}
                              />
                            </div>
                          </div>
                          <h4 className="text-warning mb-2">
                            Paul Raymond
                          </h4>
                          <h6 className="text-muted text-uppercase font-weight-bold mb-3">
                            Directeur des ventes - Ouest
                          </h6>
                          <p className="description text-muted">
                            Spécialiste du développement commercial dans l'ouest du Québec, 
                            Paul vous accompagne dans tous vos projets.
                          </p>
                          <div className="mt-4">
                            <Button
                              className="btn-neutral btn-icon-only btn-sm mb-2 mr-2"
                              color="default"
                              href="mailto:praymond@nugaz.com"
                              size="sm"
                            >
                              <span className="btn-inner--icon">
                                <i className="ni ni-email-83" />
                              </span>
                            </Button>
                            <Button
                              className="btn-neutral btn-icon-only btn-sm mb-2"
                              color="default"
                              href="tel:+4388219237"
                              size="sm"
                            >
                              <span className="btn-inner--icon">
                                <i className="ni ni-mobile-button" />
                              </span>
                            </Button>
                          </div>
                          <div className="mt-3">
                            <small className="text-muted d-block">praymond@nugaz.com</small>
                            <small className="text-muted d-block">438-821-9237</small>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4" className="mb-5">
                      <Card className="card-lift--hover shadow border-0 h-100">
                        <CardBody className="py-5 text-center">
                          <div className="mb-5 d-flex justify-content-center">
                            <div className="avatar avatar-xl">
                              <img
                                alt="Mario Cauchon"
                                style={{ 
                                  width: "150px", 
                                  height: "150px",
                                  objectFit: "cover"
                                }}
                                className="rounded-circle shadow-lg"
                                src={require("assets/img/MarioCauchon.jpg")}
                              />
                            </div>
                          </div>
                          <h4 className="text-warning mb-2">
                            Mario Cauchon
                          </h4>
                          <h6 className="text-muted text-uppercase font-weight-bold mb-3">
                            Directeur des ventes - Est
                          </h6>
                          <p className="description text-muted">
                            Expert en solutions énergétiques pour l'est du Québec, 
                            Mario met son expérience au service de vos besoins.
                          </p>
                          <div className="mt-4">
                            <Button
                              className="btn-neutral btn-icon-only btn-sm mb-2 mr-2"
                              color="default"
                              href="mailto:mcauchon@nugaz.com"
                              size="sm"
                            >
                              <span className="btn-inner--icon">
                                <i className="ni ni-email-83" />
                              </span>
                            </Button>
                            <Button
                              className="btn-neutral btn-icon-only btn-sm mb-2"
                              color="default"
                              href="tel:+5819997873"
                              size="sm"
                            >
                              <span className="btn-inner--icon">
                                <i className="ni ni-mobile-button" />
                              </span>
                            </Button>
                          </div>
                          <div className="mt-3">
                            <small className="text-muted d-block">mcauchon@nugaz.com</small>
                            <small className="text-muted d-block">581-999-7873</small>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section pb-0 pt-0">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-lg-1" lg="6">
                  <div className="d-flex px-3">
                    <div>
                      <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                        <i className="ni ni-building text-primary" />
                      </div>
                    </div>
                    <div className="pl-4">
                      <h4 className="display-3 text-black">
                        {" "}
                        Nos informations
                      </h4>
                    </div>
                  </div>
                  <Card className="shadow shadow-lg--hover mt-5">
                    <CardBody>
                      <div className="d-flex px-3">
                        <div>
                          <div className="icon icon-shape bg-gradient-info rounded-circle text-white">
                            <i className="ni ni-shop" />
                          </div>
                        </div>
                        <div className="pl-4">
                          <h5 className="title text-info">Notre emplacement</h5>
                          <p>
                            93 Boulevard Bastien, Wendake, Québec, G0A 4V0
                          </p>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                  <Card className="shadow shadow-lg--hover mt-5">
                    <CardBody>
                      <div className="d-flex px-3">
                        <div>
                          <div className="icon icon-shape bg-gradient-warning rounded-circle text-white">
                            <i className="ni ni-mobile-button" />
                          </div>
                        </div>
                        <div className="pl-4">
                          <h5 className="title text-warning">Nos téléphones</h5>
                          <p>
                            Tél:
                            <a href="tel:+4184070863"> 418-407-0863 </a>
                          </p>
                          <p>
                            Fax:
                            <a href="tel:+4184070890"> 418-407-0890 </a>
                          </p>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col className="order-lg-2 ml-lg-auto" md="6">
                  <div className="position-relative pl-md-5 ">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5456.695682655383!2d-71.3539628878205!3d46.85652673935152!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cb89879491b5827%3A0xbcf956ab875454d5!2s93%20Bd%20Bastien%2C%20Wendake%2C%20QC%20G0A%204V0!5e0!3m2!1sen!2sca!4v1755294953068!5m2!1sen!2sca" width="600" height="450" style={{borderRadius: 5}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                  </div>
                </Col>
              </Row>
            </Container>
            {/* SVG separator */}
            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              ></svg>
            </div>
          </section>
          <section className="section section-lg mt-4">
            <Container>
              <Card className="bg-gradient-warning shadow-lg border-0">
                <div className="p-5">
                  <Row className="align-items-center">
                    <Col lg="8">
                      <h3 className="text-white">
                        Au plaisir de vous rencontrer
                      </h3>
                      <p className="lead text-white mt-3">
                        N'hésitez-pas à nous contacter si vous avez des
                        questionnements à propos de Solution Nügaz
                      </p>
                    </Col>
                  </Row>
                </div>
              </Card>
            </Container>
          </section>
        </main>
        <SimpleFooter />
      </>
    );
  }
}

export default ContactPage;
